import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Category5.styled'

export const useCategory5 = props => {
	const { metaData } = props

	const sectionId = useSectionId()
	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const classes = useStyles(props)

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	return [
		{
			classes,
			direction: metaData.textPosition?.contentDirection(PageMetaData.ALIGNMENT.LEFT),
			items,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonTextEditable,
		},
		{ handleTextClick, handleButtonClick, handleTextChange, handleButtonTextChange },
	]
}
